import ApiClient from './client';
import store from '../../store';

import { getEnv } from '@/constants';

class SimuliveAPIClient extends ApiClient {
  constructor() {
    super(getEnv('VUE_APP_INHOUSE_SIMULIVE_SOURCE_v2') || '');
    this.maxAuthRetries = 5;
  }

  onUnauthorized(forced: boolean = false, error?: string): Promise<void> {
    return store.dispatch('fetchAccessToken', { isUnauthorized: true, error });
  }

  get authToken(): string {
    return store.getters.userAuthToken;
  }
}

export default new SimuliveAPIClient();
